import { type IFramework } from '@/framework';
import { type ILayerProps, type IVectorEffectShadow } from '@/version-types';
import { BaseEffect, type IBaseEffect } from './internal/base-effect';

export interface IShadowEffect {
    /**
     * 添加阴影
     * @param layerID - 图层 id
     * @param shadow - 阴影配置
     * @returns
     */
    addShadow(layerID: string, shadow: IVectorEffectShadow): ILayerProps | void;

    /**
     * 移除阴影
     * @param layerID - 图层 id
     * @returns
     */
    removeShadow(layerID: string): ILayerProps | void;

    /**
     * 设置阴影可见性
     * @param layerID - 图层 id
     * @param flag - 可见性
     * @returns
     */
    setShadowVisibility(layerID: string, flag: boolean): ILayerProps | void;

    /**
     * 更新阴影属性
     * @param layerID - 图层 id
     * @param props - 属性
     * @param options - 是否写入历史
     * @returns
     */
    adjustShadowProps(
        layerID: string,
        props: Partial<IVectorEffectShadow>,
        options?: { writeHistory?: boolean },
    ): ILayerProps | void;
}

export class ShadowEffect implements IShadowEffect {
    private baseEffect: IBaseEffect;

    constructor(framework: IFramework) {
        this.baseEffect = new BaseEffect(framework);
    }

    addShadow(layerID: string, shadow: IVectorEffectShadow) {
        return this.baseEffect.add(layerID, { kind: 'shadow', config: shadow });
    }

    removeShadow(layerID: string) {
        return this.baseEffect.remove(layerID, 'shadow');
    }

    setShadowVisibility(layerID: string, flag: boolean) {
        return this.baseEffect.setVisibility(layerID, 'shadow', flag);
    }

    adjustShadowProps(layerID: string, props: Partial<IVectorEffectShadow>, options = { writeHistory: true }) {
        return this.baseEffect.adjustEffectProps(layerID, 'shadow', props, options);
    }
}
